import { render, staticRenderFns } from "./DetailsInvoice.vue?vue&type=template&id=1038cbda&"
import script from "./DetailsInvoice.vue?vue&type=script&lang=js&"
export * from "./DetailsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports